import Dashboard from "views/Dashboard/Dashboard.jsx"; 
// import Ibs from "views/Administration/Ibs.jsx"; 
import Accounts from "views/Administration/Accounts.jsx"; 
// import Platforms from "views/Administration/Platforms.jsx"; 
import IbTree from "views/IbTree/IbTree.jsx"; 
import Clients from "views/Administration/Clients.jsx"; 
import Profiles from "views/Profiles/Profiles.jsx"; 
import Users from "views/Administration/Users.jsx"; 
import Companies from "views/Administration/Companies.jsx"; 
import Ibs from "views/Administration/Ibs.jsx"; 
import Symbols from "views/Administration/Symbols.jsx"; 
import BaseSymbols from "views/Administration/BaseSymbols.jsx"; 
import Transactions from "views/Administration/Transactions.jsx"
import Adjustments from "views/Administration/Adjustments.jsx"
import AdjustmentsReason from "views/Administration/AdjustmentsReason.jsx"
import SymbolGroups from 'views/Administration/SymbolGroups.jsx'
import IbAccountRules from 'views/Administration/IbAccountRules.jsx'
// reports
import StatementSummaryReport from 'views/Reports/StatementSummaryReport.jsx'
import ContractDetailsReport from 'views/Reports/ContractDetailsReport.jsx'
import RebateEarningsReport from 'views/Reports/RebateEarningsReport'
import TradingAccountsReport from 'views/Reports/TradingAccountsReport.jsx'
import AccountStatementReport from 'views/Reports/AccountStatementReport.jsx'

// @material-ui/icons  
import SettingsApplications from "@material-ui/icons/SettingsApplications"; 
import SettingsRounded from "@material-ui/icons/SettingsRounded"; 
import Timeline from "@material-ui/icons/Timeline"; 
import Business from "@material-ui/icons/Business";
import RecentActors from "@material-ui/icons/RecentActors";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import FileCopy from "@material-ui/icons/FileCopy";
import CallSplit from "@material-ui/icons/CallSplit";
import CompareArrows from "@material-ui/icons/CompareArrows";
import People from "@material-ui/icons/People";
import PeopleOutline from "@material-ui/icons/PeopleOutline";
import PersonAdd from "@material-ui/icons/PersonAdd";
import Person from "@material-ui/icons/Person";
//import ShowChart from "@material-ui/icons/ShowChart";
import PlaylistAddRounded from "@material-ui/icons/PlaylistAddRounded";
import Assessment from "@material-ui/icons/Assessment";
import DonutLarge from "@material-ui/icons/DonutLarge";
import CreditCard from "@material-ui/icons/CreditCard";
import Description from "@material-ui/icons/Description";
import Ballot from "@material-ui/icons/Ballot";

import { getDefaultProps } from "constants/authorisation.js";
 
const dashRoutes = (permissions) => (
  [ 
  { 
    collapse: true, 
    path: "/ib/reports", 
    name: "My Reports", 
    state: "openReports", 
    icon: Timeline, 
    component: Dashboard,
    views: [
      { 
        path: "/ib/reports/contract-details", 
        name: "Contract Details", 
        mini: "CD",
        icon: RecentActors, 
        userPermission: 'IB', 
        component: ContractDetailsReport 
      },
      { 
        path: "/ib/reports/statement-summary", 
        name: "Statement Summary", 
        mini: "STS",
        icon: DonutLarge, 
        userPermission: 'IB', 
        component: StatementSummaryReport 
      }, 
      { 
        path: "/ib/reports/trading-accounts-report", 
        name: "Trading Accounts", 
        mini: "CD",
        icon: Assessment, 
        userPermission: 'IB', 
        component: TradingAccountsReport 
      },
      {
        path: "/ib/reports/rebate-earnings", 
        name: "Rebate Earnings", 
        mini: "RE",
        icon: CreditCard, 
        userPermission: 'IB', 
        component: RebateEarningsReport
      }, 
      { 
        path: "/ib/reports/account-statement-report", 
        name: "Account Statement", 
        mini: "CD",
        icon: Description, 
        userPermission: 'IB', 
        component: AccountStatementReport 
      }
    ]
  },
  { 
    collapse: true, 
    path: '/' + getDefaultProps(permissions).ROUTECODE + "/menu", 
    name: "Administration", 
    state: "openAdministration", 
    icon: SettingsApplications, 
    component: Dashboard, 
    userPermission: 'IB', 
    views: [ 
      { 
        path: "/administration/companies", 
        name: "Companies", 
        mini: "C",
        icon: Business,
        userPermission: 'COMPANIES_MENU', 
        component: Companies 
      },
      { 
        path: "/administration/ibs", 
        name: "IBs", 
        mini: "IB",
        icon: PeopleOutline, 
        userPermission: 'IBS_MENU', 
        component: Ibs 
      },
      { 
        path: "/administration/clients", 
        name: "Clients", 
        mini: "C",
        icon: People, 
        userPermission: 'CLIENTS_MENU', 
        component: Clients 
      },
      { 
        path: "/administration/accounts", 
        name: "Trading Accounts", 
        mini: "A",
        icon: PersonAdd, 
        userPermission: 'ACCOUNTS_MENU', 
        component: Accounts 
      },  
      { 
        path: "/administration/symbols", 
        name: "Symbols", 
        mini: "S",
        icon: MonetizationOn, 
        userPermission: 'SYMBOLS_MENU', 
        component: Symbols 
      },
      {
        path: "/administration/base-symbols", 
        name: "Base Symbols (Contracts)", 
        mini: "BS",
        icon: FileCopy, 
        userPermission: 'BASE_SYMBOLS_MENU', 
        component: BaseSymbols
      },
      {
        path: "/administration/symbol-groups", 
        name: "Symbol Groups", 
        mini: "SG",
        icon: MonetizationOn, 
        userPermission: 'SYMBOLS_MENU', 
        component: SymbolGroups
      },
      { 
        path: "/administration/profiles", 
        name: "Profiles", 
        mini: "P",
        icon: RecentActors, 
        userPermission: 'PROFILES_MENU', 
        component: Profiles 
      },
      { 
        path: "/administration/ib-tree", 
        name: "IB Trees", 
        mini: "IT",
        icon: CallSplit, 
        userPermission: 'IB_TREES_MENU', 
        component: IbTree 
      },
      { 
        path: "/administration/ib-account-rules", 
        name: "IB Account Rules", 
        mini: "IT",
        icon: Ballot,
        userPermission: 'IB_ACCOUNT_RULES_MENU',
        component: IbAccountRules 
      },
      { 
        path: "/administration/transactions", 
        name: "Withdrawals", 
        mini: "T",
        icon: CompareArrows, 
        userPermission: 'WITHDRAWALS_MENU', 
        component: Transactions 
      },
      { 
        path: "/administration/adjustments", 
        name: "Adjustments", 
        mini: "AJ",
        icon: SettingsRounded, 
        userPermission: 'ADJUSTMENTS_MENU', 
        component: Adjustments 
      }, 
      { 
        path: "/administration/adjustment-reason", 
        name: "Reasons for Adjustments", 
        mini: "AR",
        icon: PlaylistAddRounded, 
        userPermission: 'ADJUSTMENTS_MENU', 
        component: AdjustmentsReason 
      },  
      { 
        path: "/administration/users", 
        name: "Users / Operators", 
        mini: "U",
        icon: Person, 
        userPermission: 'USERS_MENU', 
        component: Users 
      },
      { 
        path: "/administration/contract-details", 
        name: "Contract Details", 
        mini: "U",
        icon: Person, 
        userPermission: 'CONTRACT_DETAILS_REPORT_MENU', 
        component: ContractDetailsReport 
      },
      // { 
      //   path: "/administration/reports", 
      //   name: "Reports", 
      //   mini: "U",
      //   icon: ShowChart, 
      //   component: Dashboard 
      // } 
    ] 
  }, 
  { 
    redirect: true, 
    path: "/", 
    pathTo: "/"+getDefaultProps(permissions).ROUTECODE, 
    name: "Administration" 
  } 
]);

export default dashRoutes; 



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx